'use strict';
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import RelativeLink from "../../../common/RelativeLink";
import Row from "../../../common/Row";
import Col from "../../../common/Col";
import { Popup } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faRoute } from '@fortawesome/free-solid-svg-icons';
import { getTochtTypeClassName } from "../../../../util/tochtTypeHelper";
import IcoonErkend from "../../../../images/Icoontjes-Erkend.png";
import IcoonGSport from "../../../../images/Icoontjes-Gsport.png";
import IcoonKinderen from "../../../../images/Icoontjes-Kinderen.png";

const maxAfstandLijnen = 4;

const Tegel = (props) => {
	const {
		naam,
		datum,
		adres,
		gemeente,
		organisator,
		logo,
		isErkend,
		toegankelijkheidGSporters,
		afstanden,
		tochtId,
		toegankelijkheidVoorKinderen,
		tochtTypeId,
		tochtTypeNaam
	} = props;

	const imageSource = "data:image/png;base64," + logo;

	const className = getTochtTypeClassName(tochtTypeId);

	const afstandLijnen = afstanden && afstanden.length > maxAfstandLijnen
		? [...afstanden.slice(0, maxAfstandLijnen - 1), "..."]
		: afstanden;

	return (
		<div className={`c-fiche c-fiche--nopicture tegel ${className}`}>
			<div className="type">
				<span className="naam">{tochtTypeNaam}</span>
				<span className="badges">
					{!isErkend || <Popup content={"Tocht georganiseerd met goedkeuring van een erkende sportfederatie"} trigger={<img className="badge" src={IcoonErkend} />} />}
					{!toegankelijkheidGSporters || <Popup content={"Tocht toegankelijk voor G-sporters"} trigger={<img className="badge" src={IcoonGSport} />} />}
					{!toegankelijkheidVoorKinderen || <Popup content={"Tocht toegankelijk voor kinderen jonger dan 12 jaar"} trigger={<img className="badge" src={IcoonKinderen} />} />}
				</span>
			</div>
			<header className="c-fiche__header u-clear">
				<h1 className="title" style={{ textOverflow: "ellipsis", overflow: "hidden" }} title={naam}>
					{naam}
				</h1>
				{datum != null ?
					<abbr className="abbr">
						<Row>
							<Col size={6} className="textCenter">
								<Popup content={"datum"} trigger={<i className="fa fa-calendar fa-fw" />} /> {moment(datum).format("DD-MM-YYYY")}
							</Col>
							<Col size={6}>
								{!logo || <div className="c-tag">
									<img src={imageSource} />
								</div>}
							</Col>
						</Row>
					</abbr>
					: null}
			</header>
			<div className="c-fiche__body">
				<ul style={{ padding: "0", paddingTop: "10px" }}>
					{adres != null ?
						<li className="leaf">
							<Popup content={"adres"} trigger={<i className="fa fa-li fa-map-marker fa-fw" />} /> {adres}
						</li>
						: null}
					{gemeente != null ?
						<li className="leaf">
							{adres == null ?
								<Popup content={"adres"} trigger={<i className="fa fa-li fa-map-marker fa-fw" />} />
								: null}
							{gemeente}
						</li>
						: null}
					{organisator != null ?
						<li className="leaf">
							<Popup content={"Organisator"} trigger={<FontAwesomeIcon className="fa-li fa-fw" icon={faUsers} />} /> {organisator}
						</li>
						: null}
					{afstanden && afstanden.length > 0 ?
						<li className="leaf">
							<Popup content={"Afstanden"} trigger={<FontAwesomeIcon className="fa-li fa-fw" icon={faRoute} />} />
							{afstandLijnen.map((afstand, i) => <div key={i}>{afstand}</div>)}
						</li>
						: null}
				</ul>
			</div>
			<footer className="c-fiche__footer">
				<RelativeLink title="Meer >" to={`zoekmotor/detail/${tochtId}`} >Meer ></RelativeLink>
			</footer>
		</div>
	);
};

Tegel.propTypes = {
	naam: PropTypes.string,
	datum: PropTypes.string,
	adres: PropTypes.string,
	gemeente: PropTypes.string,
	organisator: PropTypes.string,
	logo: PropTypes.object,
	isErkend: PropTypes.bool,
	afstanden: PropTypes.array,
	tochtId: PropTypes.string,
	tochtTypeId: PropTypes.string,
	tochtTypeNaam: PropTypes.string,
	toegankelijkheidGSporters: PropTypes.bool,
	toegankelijkheidVoorKinderen: PropTypes.bool
};

export default Tegel;
